"use client";

import { useSubscriptionGate } from "src/lib/subscription-gate";

interface VisitListGateProps {
  children: React.ReactNode;
  requireSubscription?: boolean;
}

/**
 * Client wrapper that provides subscription gating for the visit list page.
 * Shows paywall modal when user doesn't have an active subscription.
 */
export function VisitListGate({
  children,
  requireSubscription = false,
}: VisitListGateProps) {
  const { renderGateModal, isGateOpen } = useSubscriptionGate({
    requireSubscription,
  });

  return (
    <>
      {children}
      {/*
       * Only mount the gate modal when it's actually open. VaulModal
       * always emits an outer wrapper `<div className={noAnimation ? ...}>` —
       * with the modal closed, that wrapper sits as a 0-height sibling of
       * {children} inside the parent's `flex flex-col gap-6`. Flex gaps
       * are applied between every pair of items regardless of size, so the
       * empty wrapper silently burns 24px below content and pushes pages
       * with tight vertical budgets (e.g. the owlet_home_variants empty
       * states) into bottom overflow. Conditional render avoids that and
       * matches how the gate is actually used — the modal only matters
       * while opened.
       */}
      {isGateOpen ? renderGateModal() : null}
    </>
  );
}
